<template>
  <div class="billManagement">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/monthlyBills' }">返回</el-breadcrumb-item>
      <el-breadcrumb-item>月度明细</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData">
        <el-form-item label="分成时间:">
          <el-date-picker v-model="formData.divideTimeStart" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>-
          <el-date-picker v-model="formData.divideTimeEnd" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="仓库名称:">
          <el-select filterable v-model="formData.organizationName" size="mini" placeholder="请选择" clearable>
            <el-option v-for="(item,index) in addKuwei" :key="index" :label="item.tenantName" :value="item.tenantName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分成状态:">
          <el-select v-model="formData.divideStatus" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="item in jiesuanOptions" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>

        <br />
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @row-click="dianjixuanzhong">
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column width="150" label="操作" align="center">
          <template v-slot="scope">
            <el-button type="text" @click="addzhangdan(scope.row,scope.row.feeMasterId)">账单明细</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeNo" label="账单号" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payCustomerName" label="结算客户" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="divideFee" label="分成金额（元）" align="center" width="150">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="orgDivideFeeProport" label="仓库分成比例（%）" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="orgDivideFee" label="仓库分成金额（元）" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="platformDivideFeeProport" label="平台分成比例（%）" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="platformDivideFee" label="平台分成金额（元）" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="divideStatus" label="分成状态" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="dividePerson" label="分成人" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="divideTime" label="分成时间" align="center" width="200"></el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <bills-detail v-if="zhangdanDetailVisible" :zhangdanDetailVisible.sync="zhangdanDetailVisible" :inventoryDivideId="inventoryDivideId"></bills-detail>
  </div>
</template>

<script>
import { getFeeMonthDetailedList } from '@/api/wms-stock'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
import { getAllTenantData } from '@/api/platform-settlement'
import BillsDetail from './billsDetail.vue'

export default {
  name: 'monthlyDetail',
  components: { BillsDetail },
  data () {
    return {
      formData: {
        divideTimeStart: '',
        divideTimeEnd: '',
        feeNo: '',
        divideStatus: '',
        organizationName: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      h: '500px',
      jiesuanOptions: [
        { id: '', name: '全部' },
        { id: '0', name: '未分账' },
        { id: '1', name: '已分账' }
      ],
      tableData: [],
      xuanzhongArr: null,
      total: 0,
      zhangdanDetailVisible: false,
      btnFlg: [],
      btnIdArr: ['003P01eB001'],
      addKuwei: [],
      inventoryDivideId: ''
    }
  },
  methods: {
    chaxun () {
      getFeeMonthDetailedList(
        {
          ...this.pageInfo,
          ...this.formData,
          feeMonthId: this.$route.query.feeMonthId
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.xuanzhongArr = null
        })
        .catch(error => {
          this.$message({ message: error.message, type: 'error' })
        })
    },
    chongzhi () {
      this.formData = {
        divideTimeStart: '',
        divideTimeEnd: '',
        feeNo: '',
        divideStatus: '',
        organizationName: ''
      }
      this.chaxun()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/inventory/exportFeeMonthDetailedList',
        { ...this.formData, feeMonthId: this.$route.query.feeMonthId },
        '月度明细'
      )
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 账单明细
    addzhangdan (row, val) {
      this.zhangdanDetailVisible = true
      this.inventoryDivideId = String(row.inventoryDivideId)
    },
    guanbi () {
      this.zhangdanDetailVisible = false
    },
    getAllTenantData () {
      getAllTenantData().then(res => {
        console.log(res)
        this.addKuwei = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 200 + 'px'
    this.btnFlg = getBtn(this.btnIdArr, '/billManagement')
    this.chaxun()
    this.getAllTenantData()
  }
}
</script>

<style lang="less" scoped>
.box {
  margin-left: 30px;
}
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
</style>
